import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { SuperAdminService } from 'src/app/services/api/super-admin.service';

@Component({
    selector: 'app-client-form',
    templateUrl: './client-form.component.html',
    styleUrls: ['./client-form.component.scss']
})

export class ClientFormComponent implements OnInit {

    public clientForm: FormGroup | undefined;

    @ViewChild('formDirective') private formDirective!: NgForm;
    
    public errorMessage: string = '';
    public errorType: string = '';
    
    constructor(private superAdminService: SuperAdminService) { }

    ngOnInit(): void {

        this.clientForm = new FormGroup({
            name: new FormControl('', [Validators.required]),
            referenceNumber: new FormControl(''),
            url: new FormControl(''),
            directory: new FormControl(false),
            cgu_mml: new FormControl(false)
        });

    }

    addClient(clientValue: any) {
        this.superAdminService.addClient(clientValue).subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.errorMessage = res.content;
                this.errorType = res.result;
                this.formDirective.resetForm();
            } else {
                this.errorMessage = res.content;
                this.errorType = res.result;
            }
        });
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.clientForm?.controls[controlName].hasError(errorName);
    }

}
